
import { Options, Vue } from "vue-class-component";
export default class ServiceMain extends Vue {
}
